import { ErrorBoundary, SuspenseLoader } from '@bechtel/client-common';
import { Alert } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { find } from 'lodash';
import { FC, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { RodRooms } from '~/rod-rooms';
import { Sync } from '~/sync';
import { WeldSetup } from '~/weld-setup';
import { ManageGeneralSettings } from '../general';
import { ProjectAdminMenuItem, ProjectAdminMenuType } from '../list/types';
import { ModuleAdmin } from '../module-admin';
import { QuantityReporting } from '../quantity-reporting';
import { UserAdmin } from '../user-admin';
import { WorkPackageAdmin } from '../work-package-admin';
import { ProjectAdminDetailContainerStyled } from './styled';
import { ProjectAdminDetailProps } from './types';

import { DataVaults } from '~/data-vault';
import { Features } from '~/features';
import { useProjectAdminTabPermissions } from '~/hooks/use-project-permissions';
import { useProjectAdminMenu } from '~/list/hooks';
import { Reports } from '~/report';
interface RouteParams {
  id: string;
}

export const ProjectAdminDetail: FC<ProjectAdminDetailProps> = ({ isListCollapsed }) => {
  const { id } = useParams<RouteParams>();
  const { getProjectAdminMenuItems } = useProjectAdminMenu();
  const {
    canViewGeneral,
    canViewUserAdmin,
    canViewModules,
    canViewFeatures,
    canViewWorkPackages,
    canViewQuantityReporting,
    canViewSync,
    canViewReports,
  } = useProjectAdminTabPermissions();

  const menuItem = find(getProjectAdminMenuItems(), (item: ProjectAdminMenuItem) => {
    return item.value == id;
  });

  return (
    <ProjectAdminDetailContainerStyled isListCollapsed={isListCollapsed}>
      {menuItem && menuItem.type === ProjectAdminMenuType.USER_ADMIN && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            {canViewUserAdmin ? (
              <UserAdmin />
            ) : (
              <Alert>
                <Trans>Sorry, you do not have permission to view User Admin</Trans>
              </Alert>
            )}
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.GENERAL && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            {canViewGeneral ? (
              <ManageGeneralSettings />
            ) : (
              <Alert>
                <Trans>Sorry, you do not have permission to view General settings</Trans>
              </Alert>
            )}
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.WORK_PACKAGES && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            {canViewWorkPackages ? (
              <WorkPackageAdmin />
            ) : (
              <Alert>
                <Trans>Sorry, you do not have permission to view Work Packages settings</Trans>
              </Alert>
            )}
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.QUANTITY_REPORTING && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            {canViewQuantityReporting ? (
              <QuantityReporting />
            ) : (
              <Alert>
                <Trans>Sorry, you do not have permission to view Quantity Reporting settings</Trans>
              </Alert>
            )}
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.MODULES && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            {canViewModules ? (
              <ModuleAdmin />
            ) : (
              <Alert>
                <Trans>Sorry, you do not have permission to view Modules settings</Trans>
              </Alert>
            )}
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.WELD_SETUP && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <WeldSetup />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.ROD_ROOMS && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <RodRooms />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.SYNC && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            {canViewSync ? (
              <Sync />
            ) : (
              <Alert>
                <Trans>Sorry, you do not have permission to view Sync settings</Trans>
              </Alert>
            )}
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.FEATURES && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            {canViewFeatures ? (
              <Features />
            ) : (
              <Alert>
                <Trans>Sorry, you do not have permission to view Features settings</Trans>
              </Alert>
            )}
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.DATA_VAULT && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <DataVaults />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.REPORT && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            {canViewReports ? (
              <Reports />
            ) : (
              <Alert>
                <Trans>Sorry, you do not have permission to view Reports settings</Trans>
              </Alert>
            )}
          </Suspense>
        </ErrorBoundary>
      )}
    </ProjectAdminDetailContainerStyled>
  );
};
